(function () {
  document.documentElement.classList.add('fb-anim-ready');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function inEditor() {
    return window.Shopify && Shopify.designMode;
  }

  function init() {
    var items = Array.prototype.slice.call(
      document.querySelectorAll('[data-fb-reveal], [data-fb-reveal-group]')
    );
    if (reduce || !items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-fb-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-fb-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  function initLoader() {
    if (inEditor() || reduce || !document.getElementById('fb-loader')) {
      document.body.classList.add('fb-loaded');
      return;
    }
    var seen = false;
    try { seen = window.sessionStorage.getItem('fb-loader-seen') === '1'; } catch (e) {}
    if (seen) {
      document.body.classList.add('fb-loaded');
      return;
    }
    try { window.sessionStorage.setItem('fb-loader-seen', '1'); } catch (e) {}
    var done = false;
    function hide() {
      if (done) return;
      done = true;
      document.body.classList.add('fb-loaded');
    }
    setTimeout(hide, 400);
    setTimeout(hide, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initLoader();
      if (inEditor()) {
        document.addEventListener('shopify:section:load', function () {
          document.querySelectorAll('[data-fb-reveal]:not(.is-fb-revealed)').forEach(function (el) {
            el.classList.add('is-fb-revealed');
          });
        });
      }
    });
  } else {
    init();
    initLoader();
  }
})();
